<template>
  <v-footer
    color="primary"
    app
    :inset="false"
  >
    <v-row
      justify="center"
      no-gutters
    >
<!--      <v-btn-->
<!--        v-for="link in links"-->
<!--        :key="link"-->
<!--        color="white"-->
<!--        text-->
<!--        rounded-->
<!--        class="my-2"-->
<!--      >-->
<!--        {{ link }}-->
<!--      </v-btn>-->
      <v-col
        class="py-4 text-center white--text"
        cols="12"
      >
        <div style="color:white;font-size:10px;"><strong>Powered by Intrare<v-spacer/>TECNOLOGÍAS EN ACCESOS CONTROLADOS SA DE CV -  {{ new Date().getFullYear() }}</strong></div>
        <v-spacer/>
                  <a style="color: #dddddd;font-size:10px;" href="https://test-club.intrare.app/notice_privacy_club" target="_blank">Aviso de privacidad Club</a>&nbsp;&nbsp;&nbsp;
                  <a style="color: #dddddd;font-size:10px;" href="https://test-club.intrare.app/notice_privacy" target="_blank">Aviso de privacidad</a>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: 'Foot',
  data: () => ({
    // links:
    //   [
    //     'Inicio',
    //     'Acerca de',
    //     'Equipo',
    //     'Servicios',
    //     'Contacto'
    //   ]
  })
}
</script>

<style scoped>

</style>
